import React, { useState, useEffect } from 'react';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import Modal from '../../common/Modal';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {CloneObject} from '../../../utils/helpers';
import {APIS} from '../../../config/apis';
import {ServerRequest} from '../../../utils/apiweb';
import ModelosAsociadosGrid from '../ModelosAsociadosGrid';
import {useSelector} from 'react-redux';
import InputActoProcesal from '../../common/InputActoProcesal';
import {TIPS} from "../../../consts/tips";
import { isValidString } from '../../../utils/validator';

import { useFormErrors } from '../../hooks/useFormErrors';
import { Accordion, DatePickerCustom, FormError, FormLabel, InputEntidad, InputLista, InputNumber } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const ActoProcesalModal = (props) => {

    const entityInit = {
        id: 0,
        idApremio: 0,
        idTipoActoProcesal: 0,
        fechaDesde: null,
        fechaHasta: null,
        observacion: '',
        recargos: 0,
        honorarios: 0,
        tasaJusticia: 0,
        sobreTasaJusticia: 0,
        bonoLey: 0,
        aportes: 0,
        multas: 0
    };
    //hooks
    const [state, setState] = useState({
        entity: entityInit
    });

    const [showSentencia, setShowSentencia] = useState(false);

    const [modeloAsociados, setModelosAsociados] = useState([]);

    const [anulacionSeleccionada, setAnulacionSeleccionada] = useState(false);

    const dataTagger = useSelector((state) => state.dataTagger.data);

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity}
        });
        formSet({
            idApremio: props.data.entity.idApremio,
            idTipoActoProcesal: props.data.entity.idTipoActoProcesal,
            fechaDesde: props.data.entity.fechaDesde,
            fechaHasta: props.data.entity.fechaHasta,
            observacion: props.data.entity.observacion,
            recargos: props.data.entity.recargos,
            honorarios: props.data.entity.honorarios,
            tasaJusticia: props.data.entity.tasaJusticia,
            sobreTasaJusticia: props.data.entity.sobreTasaJusticia,
            bonoLey: props.data.entity.bonoLey,
            aportes: props.data.entity.aportes,
            multas: props.data.entity.multas
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idApremio: 0,
        idTipoActoProcesal: 0,
        fechaDesde: null,
        fechaHasta: null,
        observacion: '',
        recargos: 0,
        honorarios: 0,
        tasaJusticia: 0,
        sobreTasaJusticia: 0,
        bonoLey: 0,
        aportes: 0,
        multas: 0
    });

    useEffect(() => {
        if (formValues && formValues.idTipoActoProcesal > 0) {
            SearchModelosAsociados(formValues.idTipoActoProcesal);
        }
    }, [formValues]);

    const [datosOpen, setDatosOpen] = useState(true);

    const { errorOf, validate } = useFormErrors(getErrors);

    function getErrors() {

        const errors = {};

        if (formValues.idTipoActoProcesal <= 0) errors.idTipoActoProcesal = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.fechaDesde == null) errors.fechaDesde = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (!isValidString(formValues.observacion, anulacionSeleccionada)) errors.observacion = VALIDATION_MESSAGE.REQUIRED;

        return errors;
    }

    //handles
    const handleClickAceptar = () => {
        if (isFormValid()) {
            let row = CloneObject(state.entity);

            row.idApremio = parseInt(formValues.idApremio);
            row.idTipoActoProcesal = parseInt(formValues.idTipoActoProcesal);
            row.fechaDesde = formValues.fechaDesde;
            row.fechaHasta = formValues.fechaHasta;
            row.observacion = formValues.observacion;
            row.recargos = formValues.recargos
            row.honorarios = formValues.honorarios
            row.tasaJusticia = formValues.tasaJusticia
            row.sobreTasaJusticia = formValues.sobreTasaJusticia
            row.bonoLey = formValues.bonoLey
            row.aportes = formValues.aportes
            row.multas = formValues.multas

            props.onConfirm(row);
        }
        ;
    };

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessSearchModelosAsociados = (response) => {
        response.json()
            .then((data) => {
                setModelosAsociados(data);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    };

    //funciones
    function SearchModelosAsociados(idTipoActoProcesal) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/tipo-acto-procesal/${idTipoActoProcesal}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PLANTILLA_DOCUMENTO,
            paramsUrl,
            null,
            callbackSuccessSearchModelosAsociados,
            callbackNoSuccess,
            callbackError
        );

    }

    function isFormValid() {

        if (!validate()) {
            setDatosOpen(true);
            return false;
        }

        const archivos = (dataTagger[props.processKey]) ?
            dataTagger[props.processKey].Archivo
                .filter(f => f.state !== 'r' && f.entidad === 'ActoProcesal' && f.idEntidad === state.entity.id) ?? [] : [];
        if (archivos.length === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe ingresar un documento en información adicional');
            return false;
        }

        return true;
    }


    return (
        <>

            <Modal
                size="lg"
                title={`Acto procesal: ${(state.entity.id > 0) ? `N° ${state.entity.id}` : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.ACTO_PROCESAL_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Acto procesal" open={datosOpen} onToggle={setDatosOpen}>
                                            <div className='row form-basic'>
                                                <div className="mb-3 col-12 col-md-6">
                                                    <FormLabel htmlFor="idTipoActoProcesal" required>Tipo de
                                                        acto procesal</FormLabel>
                                                    <InputActoProcesal
                                                        name="idTipoActoProcesal"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('idTipoActoProcesal') ? 'is-invalid' : ''}`}
                                                        value={formValues.idTipoActoProcesal}
                                                        onUpdate={({target}) => {
                                                            setShowSentencia((target.row) ? target.row.sentencia : false);
                                                            setAnulacionSeleccionada((target.row) ? target.row.anulacion : false);
                                                        }}
                                                        onChange={({target}) => {
                                                            formSet({
                                                                ...formValues,
                                                                idTipoActoProcesal: (target.row) ? target.row.id : 0
                                                            });
                                                            setShowSentencia((target.row) ? target.row.sentencia : false);
                                                            setAnulacionSeleccionada((target.row) ? target.row.anulacion : false);
                                                        }}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('idTipoActoProcesal')} />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <FormLabel htmlFor="fechaDesde" required>Fecha
                                                        desde</FormLabel>
                                                    <DatePickerCustom
                                                        name="fechaDesde"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                                                        value={formValues.fechaDesde}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('fechaDesde')} />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <label htmlFor="fechaHasta" className="form-label">Fecha
                                                        hasta</label>
                                                    <DatePickerCustom
                                                        name="fechaHasta"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaHasta}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        minValue={formValues.fechaDesde}
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="mb-3 col-12">
                                                    <FormLabel htmlFor="observacion"
                                                           required={anulacionSeleccionada}>Observaciones</FormLabel>
                                                    <textarea
                                                        name="observacion"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('observacion') ? 'is-invalid' : ''}`}
                                                        value={formValues.observacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        rows="4"
                                                        maxLength="1000"
                                                    />
                                                    <FormError message={errorOf('observacion')} />
                                                </div>

                                            </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Modelos asociados">
                                            <ModelosAsociadosGrid
                                                disabled={props.disabled}
                                                data={{
                                                    list: modeloAsociados
                                                }}
                                            />
                                    </Accordion>
                                </div>

                                {showSentencia &&
                                    <div className="mb-3 col-12">
                                        <Accordion title="Sentencia - Carga de montos">
                                            <div className="row form-basic">
                                                <div className="col-6 col-lg-4">
                                                    <label htmlFor="recargos" className="form-label">Recargos
                                                       </label>
                                                    <InputNumber
                                                        name="recargos"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.recargos}
                                                        onChange={formHandle}
                                                        precision={2}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-lg-4">
                                                    <label htmlFor="honorarios" className="form-label">Honorarios
                                                       </label>
                                                    <InputNumber
                                                        name="honorarios"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.honorarios}
                                                        onChange={formHandle}
                                                        precision={2}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-lg-4">
                                                    <label htmlFor="tasaJusticia" className="form-label">Tasa justicia
                                                       </label>
                                                    <InputNumber
                                                        name="tasaJusticia"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.tasaJusticia}
                                                        onChange={formHandle}
                                                        precision={2}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-lg-4">
                                                    <label htmlFor="sobreTasaJusticia" className="form-label">Sobre tasa
                                                        justicia</label>
                                                    <InputNumber
                                                        name="sobreTasaJusticia"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.sobreTasaJusticia}
                                                        onChange={formHandle}
                                                        precision={2}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-lg-4">
                                                    <label htmlFor="bonoLey" className="form-label">Bono Ley</label>
                                                    <InputNumber
                                                        name="bonoLey"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.bonoLey}
                                                        onChange={formHandle}
                                                        precision={2}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-lg-4">
                                                    <label htmlFor="aportes" className="form-label">Aportes</label>
                                                    <InputNumber
                                                        name="aportes"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.aportes}
                                                        onChange={formHandle}
                                                        precision={2}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                {/*
                                                    <div className="col-6 col-lg-4">
                                                        <label htmlFor="multas" className="form-label">Multas</label>
                                                        <InputNumber
                                                            name="multas"
                                                            placeholder=""
                                                            className="form-control"
                                                            value={ formValues.multas }
                                                            onChange={ formHandle }
                                                            precision={2}
                                                            disabled={props.disabled}
                                                        />
                                                    </div> */
                                                }
                                            </div>
                                        </Accordion>
                                    </div>
                                }

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                            <DataTaggerFormRedux
                                                title="Información adicional de Acto Procesal"
                                                processKey={props.processKey}
                                                entidad="ActoProcesal"
                                                idEntidad={state.entity.id}
                                                disabled={props.disabled}
                                            />
                                    </Accordion>
                                </div>
                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}


export default ActoProcesalModal;